export enum MessagePopupPriority {
  Priority_PublicityPopup = 900,
  Priority_Highest = 1000,
}
